// import {
//   ActivityIndicator,
//   Alert,
//   Image,
//   ImageBackground,
//   Modal,
//   Platform,
//   StyleSheet,
//   Text,
//   TextInput,
//   TouchableOpacity,
//   View,
// } from "react-native";
// import React, { useEffect, useState } from "react";
// import { AppIcons } from "../../../assets/images";
// import {
//   useIsFocused,
//   useNavigation,
//   useRoute,
// } from "@react-navigation/native";
// import { NativeStackNavigationProp } from "@react-navigation/native-stack";
// import { AppTheme } from "../../../utils/theme";
// import FastImage from "react-native-fast-image";
// import LinearGradient from "react-native-linear-gradient";
// import { BASE_URL, playerCountList } from "../../../utils/contants";
// import Spacer from "../../../components/global/Spacer";
// import { ROUTE_NAME } from "../../../utils/routes";
// import { useAppSelector } from "../../../redux/storeHook";
// import socketService from "../../../services/socketService";
// import { PERMISSIONS, request, RESULTS } from "react-native-permissions";
// import SoundPlayer from "react-native-sound-player";
// import { userAction } from "../../../redux/reducers/user";
// import { useKeyboardPadding } from "../../../utils/KeyboardPadding";

// const PlayerRoom = () => {
//   const route = useRoute();
//   const params = route.params as any;
//   const navigation = useNavigation<NativeStackNavigationProp<any>>();
//   const [type, setType] = useState<"create" | "join">("create");
//   const [selectedCount, setSelectedCount] = useState<number>(2);
//   const { userData } = useAppSelector((s) => s.user);
//   const [roomId, setRoomId] = useState(params?.roomId || "");
//   const [loading, setLoading] = useState(false);
//   const [connecting, setConnecting] = useState(true);
//   const { isMusicOn, isPlayMusicOn } = useAppSelector((state) => state.user);
//   const isFocused = useIsFocused();
//   const keyboardPadding = useKeyboardPadding();

//   const onPress = () => {
//     if (type == "create") {
//       handleCreateRoom();
//     } else if (type == "join") {
//       handleJoinRoom();
//     }
//     // navigation.navigate(ROUTE_NAME.WaitingRoom)
//   };

//   useEffect(() => {
//     connectToServer();

//     return () => {
//       socketService.removeAllListeners();
//     };
//   }, []);

//   useEffect(() => {
//     if (isMusicOn && isPlayMusicOn) {
//       userAction.setTouchSound(true); // Trigger touch sound on start
//       userAction.setMusicPreference(true);
//     }
//   }, [isFocused]);

//   const connectToServer = async () => {
//     try {
//       setConnecting(true);
//       await socketService.connect(BASE_URL);
//       setConnecting(false);
//       if (params?.roomId) {
//         handleJoinRoom();
//       }
//     } catch (error) {
//       setConnecting(false);
//       Alert.alert(
//         "Connection Error",
//         "Failed to connect to server. Please try again."
//       );
//     }
//   };

//   const requestMicrophonePermission = async () => {
//     try {
//       const permission =
//         Platform.OS === "ios"
//           ? PERMISSIONS.IOS.MICROPHONE
//           : PERMISSIONS.ANDROID.RECORD_AUDIO;

//       const result = await request(permission);

//       switch (result) {
//         case RESULTS.GRANTED:
//           return true; // permission allowed
//         case RESULTS.BLOCKED:
//           console.log("Permission blocked. Open settings.");
//           return false;
//         case RESULTS.DENIED:
//           console.log("Permission denied by user.");
//           return false;
//         default:
//           return false;
//       }
//     } catch (error) {
//       console.log("Permission error:", error);
//       return false;
//     }
//   };

//   const handleCreateRoom = async () => {
//     if (!userData?.name) {
//       Alert.alert("Error", "Please enter your name");
//       return;
//     }
//     setLoading(true);
//     try {
//       await requestMicrophonePermission();
//       const response: any = await socketService.createRoom(
//         userData?.name,
//         selectedCount
//       );
//       setLoading(false);

//       // Navigate to waiting room
//       navigation.replace(ROUTE_NAME.WaitingRoom, {
//         roomId: response?.roomId,
//         playerName: userData?.name,
//         color: response?.color,
//         isHost: true,
//         room: response?.room,
//       });
//     } catch (error) {
//       setLoading(false);
//       // @ts-ignore
//       Alert.alert("Error", error || "Failed to create room");
//     }
//   };
//   const handleJoinRoom = async () => {
//     if (!userData?.name) {
//       Alert.alert("Error", "Please enter your name");
//       return;
//     }
//     if (!roomId.trim()) {
//       Alert.alert("Error", "Please enter room ID");
//       return;
//     }
//     setLoading(true);
//     try {
//       await requestMicrophonePermission();
//       const response: any = await socketService.joinRoom(
//         roomId.trim().toUpperCase(),
//         userData?.name
//       );
//       setLoading(false);

//       // Navigate to waiting room
//       navigation.replace(ROUTE_NAME.WaitingRoom, {
//         roomId: roomId.trim().toUpperCase(),
//         playerName: userData?.name,
//         color: response.color,
//         isHost: false,
//         room: response.room,
//       });
//     } catch (error) {
//       setLoading(false);
//       // @ts-ignore
//       Alert.alert("Error", error || "Failed to join room");
//     }
//   };

//   return (
//     <ImageBackground
//       source={AppIcons.screenBackground}
//       style={[styles.mainView, { paddingBottom: keyboardPadding }]}
//     >
//       <TouchableOpacity
//         onPress={() => {
//           navigation.goBack();
//           userAction.setTouchSound(true);
//         }}
//         style={styles.backIcon}
//       >
//         <Image
//           source={AppIcons.BackIcon}
//           style={{
//             width: 50,
//             height: 40,
//           }}
//           resizeMode="contain"
//         />
//       </TouchableOpacity>
//       <View style={styles.container}>
//         <Text style={styles.title}>Play Online</Text>
//         <Spacer size={50} />
//         <View style={styles.btnView}>
//           <TouchableOpacity
//             style={styles.btn}
//             activeOpacity={1}
//             onPress={() => {
//               setType("create");
//               userAction.setTouchSound(true);
//             }}
//           >
//             <FastImage
//               source={
//                 type == "create" ? AppIcons.ActiveBtn : AppIcons.InactiveBtn
//               }
//               resizeMode="contain"
//               style={[
//                 styles.btnImg,
//                 {
//                   marginTop: type == "create" ? 0 : -10,
//                 },
//               ]}
//             >
//               <Image
//                 source={AppIcons.CreateRoom}
//                 style={[
//                   styles.smallIcon,
//                   {
//                     top: type == "create" ? -25 : -15,
//                   },
//                 ]}
//               />
//               <Text
//                 style={[
//                   styles.btnText,
//                   {
//                     marginBottom: type == "create" ? 40 : 30,
//                   },
//                 ]}
//               >
//                 Create Room
//               </Text>
//             </FastImage>
//           </TouchableOpacity>
//           <TouchableOpacity
//             style={styles.btn}
//             activeOpacity={1}
//             onPress={() => {
//               setType("join");
//               userAction.setTouchSound(true);
//             }}
//           >
//             <FastImage
//               source={
//                 type == "join" ? AppIcons.ActiveBtn : AppIcons.InactiveBtn
//               }
//               resizeMode="contain"
//               style={[
//                 styles.btnImg,
//                 {
//                   marginTop: type == "join" ? 0 : -10,
//                 },
//               ]}
//             >
//               <Image
//                 source={AppIcons.JoinRoom}
//                 style={[
//                   styles.smallIcon,
//                   {
//                     top: type == "join" ? -25 : -15,
//                   },
//                 ]}
//               />
//               <Text
//                 style={[
//                   styles.btnText,
//                   {
//                     marginBottom: type == "join" ? 40 : 30,
//                   },
//                 ]}
//               >
//                 Join Room
//               </Text>
//             </FastImage>
//           </TouchableOpacity>
//         </View>
//         <Spacer size={30} />
//         <FastImage
//           source={AppIcons.SelectTokenBackground}
//           style={styles.selectdeTokenBack}
//           resizeMode={FastImage.resizeMode.contain}
//         >
//           <Text style={styles.chooseText}>
//             {type == "create" ? "Select No. of Players" : "Enter room ID"}
//           </Text>
//           {type == "create" ? (
//             <View style={styles.playerListView}>
//               {playerCountList.map((item) => {
//                 return (
//                   <TouchableOpacity
//                     activeOpacity={1}
//                     onPress={() => {
//                       userAction.setTouchSound(true);
//                       setSelectedCount(item.numPlayers);
//                     }}
//                     key={item.id}
//                     style={styles.playerItem}
//                   >
//                     <Image source={item.icon} style={styles.playerIcon1} />
//                     <Text style={styles.label1}>{item.label}</Text>
//                     {item.numPlayers === selectedCount ? (
//                       <Image source={AppIcons.TickIcon} style={styles.tick} />
//                     ) : (
//                       <Image source={AppIcons.UnTickIcon} style={styles.tick} />
//                     )}
//                   </TouchableOpacity>
//                 );
//               })}
//             </View>
//           ) : (
//             <View style={styles.inputView}>
//               <TextInput
//                 placeholder="Enter room code here"
//                 style={styles.input}
//                 placeholderTextColor={`${AppTheme.colors.white}80`}
//                 autoCapitalize="characters"
//                 maxLength={6}
//                 value={roomId}
//                 onChangeText={(text) => {
//                   setRoomId(text);
//                 }}
//               />
//             </View>
//           )}
//         </FastImage>
//         <TouchableOpacity
//           activeOpacity={1}
//           style={{ alignSelf: "center", marginTop: 20 }}
//           onPress={() => {
//             onPress();
//             // SoundPlayer.stop();
//             // userAction.setMusicPreference(false);
//             // userAction.setTouchSound(true);
//           }}
//         >
//           <LinearGradient
//             colors={[
//               AppTheme.colors.linearGradient_5,
//               AppTheme.colors.linearGradient_6,
//             ]}
//             start={{ x: 0, y: 0 }}
//             end={{ x: 1, y: 1 }}
//             style={styles.googleBtn1}
//           >
//             <LinearGradient
//               colors={[
//                 AppTheme.colors.linearGradient_1,
//                 AppTheme.colors.linearGradient_2,
//               ]}
//               start={{ x: 0, y: 0 }}
//               end={{ x: 1, y: 1 }}
//               style={styles.googleBtn}
//             >
//               {loading ? (
//                 <ActivityIndicator
//                   size={"large"}
//                   color={AppTheme.colors.white}
//                 />
//               ) : (
//                 <Text style={styles.startText}>NEXT</Text>
//               )}
//             </LinearGradient>
//           </LinearGradient>
//         </TouchableOpacity>
//       </View>
//       <Modal transparent visible={connecting} style={{ flex: 1 }}>
//         <View style={styles.modalView}>
//           <ActivityIndicator size={"large"} color={AppTheme.colors.white} />
//           <Text style={styles.title}>Connecting to server...</Text>
//         </View>
//       </Modal>
//     </ImageBackground>
//   );
// };

// export default PlayerRoom;

// const styles = StyleSheet.create({
//   mainView: {
//     flex: 1,
//   },
//   backIcon: {
//     position: "absolute",
//     top: 70,
//     right: 0,
//   },
//   container: {
//     flex: 1,
//     justifyContent: "center",
//   },
//   title: {
//     alignSelf: "center",
//     fontSize: 36,
//     fontFamily: AppTheme.fonts.BUBBLE_BOBBLE,
//     color: AppTheme.colors.white,
//     textShadowColor: AppTheme.colors.outline,
//     textShadowOffset: { width: 2, height: 2 },
//     textShadowRadius: 2,
//   },
//   btnView: {
//     width: "100%",
//     flexDirection: "row",
//     alignItems: "center",
//     justifyContent: "space-between",
//     paddingHorizontal: 14,
//   },
//   btn: {
//     width: "49%",
//     height: 130,
//   },
//   btnImg: {
//     width: "100%",
//     height: "100%",
//     position: "relative",
//     overflow: "visible",
//     justifyContent: "flex-end",
//   },
//   smallIcon: {
//     position: "absolute",
//     width: 90,
//     height: 90,
//     alignSelf: "center",
//     zIndex: 999,
//   },
//   btnText: {
//     alignSelf: "center",
//     fontSize: 24,
//     fontFamily: AppTheme.fonts.BUBBLE_BOBBLE,
//     color: AppTheme.colors.white,
//     textShadowColor: AppTheme.colors.outline,
//     textShadowOffset: { width: 2, height: 2 },
//     textShadowRadius: 2,
//   },
//   selectdeTokenBack: {
//     width: "95%",
//     height: 270,
//     alignSelf: "center",
//     paddingTop: 20,
//   },
//   chooseText: {
//     textAlign: "center",
//     color: AppTheme.colors.white,
//     fontFamily: AppTheme.fonts.ALEXANDRIA_BOLD,
//     fontSize: 25,
//   },
//   playerIcon1: {
//     width: 80,
//     height: 80,
//   },
//   label1: {
//     fontSize: 20,
//     fontFamily: AppTheme.fonts.BUBBLE_BOBBLE,
//     color: AppTheme.colors.white,
//     textShadowColor: AppTheme.colors.outline,
//     textShadowOffset: { width: 2, height: 2 },
//     textShadowRadius: 2,
//   },
//   tick: {
//     width: 30,
//     height: 30,
//     marginTop: 10,
//   },
//   googleBtn: {
//     width: 250,
//     height: 58,
//     borderRadius: 30,
//     justifyContent: "center",
//   },

//   googleBtn1: {
//     width: 250,
//     height: 65,
//     borderRadius: 35,
//   },
//   startText: {
//     fontFamily: AppTheme.fonts.BUBBLE_BOBBLE,
//     fontSize: 35,
//     color: AppTheme.colors.white,
//     textAlign: "center",
//     textShadowColor: AppTheme.colors.outline,
//     textShadowOffset: { width: 2, height: 2 },
//     textShadowRadius: 2,
//   },
//   playerListView: {
//     alignItems: "center",
//     flexDirection: "row",
//     justifyContent: "space-between",
//     marginHorizontal: 10,
//     paddingHorizontal: 14,
//   },
//   playerItem: {
//     marginTop: 15,
//     alignItems: "center",
//   },
//   playerback: {
//     justifyContent: "center",
//     alignItems: "center",
//     padding: 15,
//   },
//   playerIcon: {
//     width: 80,
//     height: 80,
//   },
//   label: {
//     fontSize: 20,
//     color: AppTheme.colors.white,
//     fontFamily: AppTheme.fonts.BUBBLE_BOBBLE,
//     textShadowColor: AppTheme.colors.outline,
//     textShadowOffset: { width: 2, height: 2 },
//     textShadowRadius: 2,
//   },
//   inputView: {
//     width: "85%",
//     height: 50,
//     backgroundColor: `${AppTheme.colors.linearGradient_10}50`,
//     alignSelf: "center",
//     marginTop: 30,
//     borderRadius: 10,
//     borderWidth: 1,
//     borderColor: AppTheme.colors.linearGradient_10,
//     paddingHorizontal: 10,
//   },
//   input: {
//     flex: 1,
//     color: AppTheme.colors.white,
//     fontSize: 18,
//     fontFamily: AppTheme.fonts.ALEXANDRIA_MEDIUM,
//   },
//   modalView: {
//     flex: 1,
//     alignItems: "center",
//     justifyContent: "center",
//     backgroundColor: `${AppTheme.colors.black}90`,
//   },
// });

import {
  ActivityIndicator,
  Alert,
  Image,
  ImageBackground,
  Modal,
  Platform,
  StyleSheet,
  Text,
  TextInput,
  TouchableOpacity,
  View,
} from "react-native";
import React, { useEffect, useRef, useState } from "react";
import { AppIcons } from "../../../assets/images";
import {
  useIsFocused,
  useNavigation,
  useRoute,
} from "@react-navigation/native";
import { NativeStackNavigationProp } from "@react-navigation/native-stack";
import { AppTheme } from "../../../utils/theme";
import FastImage from "react-native-fast-image";
import LinearGradient from "react-native-linear-gradient";
import {
  bannerAdKey,
  BASE_URL,
  interstitial,
  playerCountList,
} from "../../../utils/contants";
import Spacer from "../../../components/global/Spacer";
import { ROUTE_NAME } from "../../../utils/routes";
import { useAppSelector } from "../../../redux/storeHook";
import socketService from "../../../services/socketService";
import { PERMISSIONS, request, RESULTS } from "react-native-permissions";
import SoundPlayer from "react-native-sound-player";
import { userAction } from "../../../redux/reducers/user";
import { useKeyboardPadding } from "../../../utils/KeyboardPadding";
import { setAppOpenAdPaused } from "../../../utils/useOpenAppAd";
import {
  AdEventType,
  BannerAd,
  BannerAdSize,
  useForeground,
} from "react-native-google-mobile-ads";

const PlayerRoom = () => {
  const route = useRoute();
  const params = route.params as any;
  const navigation = useNavigation<NativeStackNavigationProp<any>>();
  const [type, setType] = useState<"create" | "join">("create");
  const [selectedCount, setSelectedCount] = useState<number>(2);
  const { userData } = useAppSelector((s) => s.user);
  const [roomId, setRoomId] = useState(params?.roomId || "");
  const [loading, setLoading] = useState(false);
  const [connecting, setConnecting] = useState(true);
  const { isMusicOn, isPlayMusicOn } = useAppSelector((state) => state.user);
  const isFocused = useIsFocused();
  const keyboardPadding = useKeyboardPadding();
  const bannerRef = useRef<BannerAd>(null);

   useForeground(() => {
      if (Platform.OS === "ios") {
        bannerRef.current?.load();
      }
    });

  // useEffect(() => {
  //   const unsubscribeLoaded = interstitial.addAdEventListener(
  //     AdEventType.LOADED,
  //     () => {
  //       console.log("@ interstitial ad loaded");
  //     },
  //   );
  //   const unsubscribeOpened = interstitial.addAdEventListener(
  //     AdEventType.OPENED,
  //     () => {
  //       console.log("@ interstitial ad opened");
  //     },
  //   );
  //   const unsubscribeClosed = interstitial.addAdEventListener(
  //     AdEventType.CLOSED,
  //     () => {
  //       console.log("@ interstitial ad closed");
  //     },
  //   );
  //   // interstitial.load();
  //   return () => {
  //     unsubscribeLoaded();
  //     unsubscribeOpened();
  //     unsubscribeClosed();
  //   };
  // }, []);

  const onPress = () => {
    if (type == "create") {
      handleCreateRoom();
    } else if (type == "join") {
      handleJoinRoom();
    }
    // navigation.navigate(ROUTE_NAME.WaitingRoom)
  };

  useEffect(() => {
    connectToServer();

    return () => {
      socketService.removeAllListeners();
    };
  }, []);

  useEffect(() => {
    if (isMusicOn && isPlayMusicOn) {
      userAction.setTouchSound(true); // Trigger touch sound on start
      userAction.setMusicPreference(true);
    }
  }, [isFocused]);

  const connectToServer = async () => {
    try {
      setConnecting(true);
      await socketService.connect(BASE_URL);
      setConnecting(false);
      // if (Platform.OS === "android") {
      //   if (interstitial.loaded) {
      //     interstitial.show();
      //   } else {
      //     interstitial.load();
      //   }
      // }
      if (params?.roomId) {
        handleJoinRoom();
      }
    } catch (error) {
      setConnecting(false);
      // if (interstitial.loaded) {
      //   interstitial.show();
      //   // setAdLoaded(false);
      // } else {
      //   interstitial.load();
      // }
      Alert.alert(
        "Connection Error",
        "Failed to connect to server. Please try again.",
      );
    }
  };

  const requestMicrophonePermission = async () => {
    try {
      const permission =
        Platform.OS === "ios"
          ? PERMISSIONS.IOS.MICROPHONE
          : PERMISSIONS.ANDROID.RECORD_AUDIO;

      let result;
      try {
        setAppOpenAdPaused(true);
        result = await request(permission);
      } finally {
        setAppOpenAdPaused(false, 3000);
      }

      switch (result) {
        case RESULTS.GRANTED:
          return true; // permission allowed
        case RESULTS.BLOCKED:
          console.log("Permission blocked. Open settings.");
          return false;
        case RESULTS.DENIED:
          console.log("Permission denied by user.");
          return false;
        default:
          return false;
      }
    } catch (error) {
      console.log("Permission error:", error);
      return false;
    }
  };

  const handleCreateRoom = async () => {
    if (!userData?.name) {
      Alert.alert("Error", "Please enter your name");
      return;
    }
    if (!userData?._id) {
      Alert.alert("Error", "User ID not found. Please log in again.");
      return;
    }
    setLoading(true);
    try {
      await requestMicrophonePermission();
      const response: any = await socketService.createRoom(
        userData?.name,
        userData?.profilePicture || "",
        selectedCount,
        userData._id,
      );
      setLoading(false);
      console.log("@ create room socket response : ", response);

      // Navigate to waiting room
      navigation.replace(ROUTE_NAME.WaitingRoom, {
        roomId: response?.roomId,
        playerName: userData?.name,
        color: response?.color,
        isHost: true,
        userId: userData._id,
        room: response?.room,
      });
    } catch (error) {
      setLoading(false);
      // @ts-ignore
      Alert.alert("Error", error || "Failed to create room");
    }
  };
  const handleJoinRoom = async () => {
    if (!userData?.name) {
      Alert.alert("Error", "Please enter your name");
      return;
    }
    if (!userData?._id) {
      Alert.alert("Error", "User ID not found. Please log in again.");
      return;
    }
    if (!roomId.trim()) {
      Alert.alert("Error", "Please enter room ID");
      return;
    }
    setLoading(true);
    try {
      await requestMicrophonePermission();
      const response: any = await socketService.joinRoom(
        roomId.trim().toUpperCase(),
        userData?.name,
        userData?.profilePicture || "",
        userData._id,
      );
      setLoading(false);

      // Navigate to waiting room
      navigation.replace(ROUTE_NAME.WaitingRoom, {
        roomId: roomId.trim().toUpperCase(),
        playerName: userData?.name,
        color: response.color,
        isHost: false,
        userId: userData._id,
        room: response.room,
      });
    } catch (error) {
      setLoading(false);
      // @ts-ignore
      Alert.alert("Error", error || "Failed to join room");
    }
  };

  return (
    <ImageBackground
      source={AppIcons.screenBackground}
      style={[styles.mainView, { paddingBottom: keyboardPadding }]}
    >
      <TouchableOpacity
        onPress={() => {
          navigation.goBack();
          userAction.setTouchSound(true);
        }}
        style={styles.backIcon}
      >
        <Image
          source={AppIcons.BackIcon}
          style={{
            width: 50,
            height: 40,
          }}
          resizeMode="contain"
        />
      </TouchableOpacity>
      <View style={styles.container}>
        <Text style={styles.title}>Play with friends</Text>
        <Text style={styles.text}>
          only {userData?.allowedEntryFees} coins to play
        </Text>
        <Spacer size={50} />
        <View style={styles.btnView}>
          <TouchableOpacity
            style={styles.btn}
            activeOpacity={1}
            onPress={() => {
              setType("create");
              userAction.setTouchSound(true);
            }}
          >
            <FastImage
              source={
                type == "create" ? AppIcons.ActiveBtn : AppIcons.InactiveBtn
              }
              resizeMode="contain"
              style={[
                styles.btnImg,
                {
                  marginTop: type == "create" ? 0 : -10,
                },
              ]}
            >
              <Image
                source={AppIcons.CreateRoom}
                style={[
                  styles.smallIcon,
                  {
                    top: type == "create" ? -25 : -15,
                  },
                ]}
              />
              <Text
                style={[
                  styles.btnText,
                  {
                    marginBottom: type == "create" ? 40 : 30,
                  },
                ]}
              >
                Create Room
              </Text>
            </FastImage>
          </TouchableOpacity>
          <TouchableOpacity
            style={styles.btn}
            activeOpacity={1}
            onPress={() => {
              setType("join");
              userAction.setTouchSound(true);
            }}
          >
            <FastImage
              source={
                type == "join" ? AppIcons.ActiveBtn : AppIcons.InactiveBtn
              }
              resizeMode="contain"
              style={[
                styles.btnImg,
                {
                  marginTop: type == "join" ? 0 : -10,
                },
              ]}
            >
              <Image
                source={AppIcons.JoinRoom}
                style={[
                  styles.smallIcon,
                  {
                    top: type == "join" ? -25 : -15,
                  },
                ]}
              />
              <Text
                style={[
                  styles.btnText,
                  {
                    marginBottom: type == "join" ? 40 : 30,
                  },
                ]}
              >
                Join Room
              </Text>
            </FastImage>
          </TouchableOpacity>
        </View>
        <Spacer size={30} />
        <FastImage
          source={AppIcons.SelectTokenBackground}
          style={styles.selectdeTokenBack}
          resizeMode={FastImage.resizeMode.stretch}
        >
          <Text style={styles.chooseText}>
            {type == "create" ? "Select No. of Players" : "Enter room ID"}
          </Text>
          {type == "create" ? (
            <View style={styles.playerListView}>
              {playerCountList.map((item) => {
                return (
                  <TouchableOpacity
                    activeOpacity={1}
                    onPress={() => {
                      userAction.setTouchSound(true);
                      setSelectedCount(item.numPlayers);
                    }}
                    key={item.id}
                    style={styles.playerItem}
                  >
                    <Image source={item.icon} style={styles.playerIcon1} />
                    <Text style={styles.label1}>{item.label}</Text>
                    {item.numPlayers === selectedCount ? (
                      <Image source={AppIcons.TickIcon} style={styles.tick} />
                    ) : (
                      <Image source={AppIcons.UnTickIcon} style={styles.tick} />
                    )}
                  </TouchableOpacity>
                );
              })}
            </View>
          ) : (
            <View style={styles.inputView}>
              <TextInput
                placeholder="Enter room code here"
                style={styles.input}
                placeholderTextColor={`${AppTheme.colors.white}80`}
                autoCapitalize="characters"
                maxLength={6}
                value={roomId}
                onChangeText={(text) => {
                  setRoomId(text);
                }}
              />
            </View>
          )}
        </FastImage>
        <TouchableOpacity
          activeOpacity={1}
          style={{ alignSelf: "center", marginTop: 20 }}
          onPress={() => {
            onPress();
            // SoundPlayer.stop();
            // userAction.setMusicPreference(false);
            // userAction.setTouchSound(true);
          }}
        >
          <LinearGradient
            colors={[
              AppTheme.colors.linearGradient_5,
              AppTheme.colors.linearGradient_6,
            ]}
            start={{ x: 0, y: 0 }}
            end={{ x: 1, y: 1 }}
            style={styles.googleBtn1}
          >
            <LinearGradient
              colors={[
                AppTheme.colors.linearGradient_1,
                AppTheme.colors.linearGradient_2,
              ]}
              start={{ x: 0, y: 0 }}
              end={{ x: 1, y: 1 }}
              style={styles.googleBtn}
            >
              {loading ? (
                <ActivityIndicator
                  size={"large"}
                  color={AppTheme.colors.white}
                />
              ) : (
                <Text style={styles.startText}>NEXT</Text>
              )}
            </LinearGradient>
          </LinearGradient>
        </TouchableOpacity>
      </View>
      <Modal transparent visible={connecting} style={{ flex: 1 }}>
        <View style={styles.modalView}>
          <ActivityIndicator size={"large"} color={AppTheme.colors.white} />
          <Text style={styles.title}>Connecting to server...</Text>
        </View>
      </Modal>
      <View style={styles.botttomView}>
        <BannerAd
          ref={bannerRef}
          unitId={bannerAdKey}
          size={BannerAdSize.ANCHORED_ADAPTIVE_BANNER}
        />
      </View>
    </ImageBackground>
  );
};

export default PlayerRoom;

const styles = StyleSheet.create({
  mainView: {
    flex: 1,
    paddingHorizontal: 16,
  },
  backIcon: {
    position: "absolute",
    top: 70,
    right: 0,
    zIndex: 999,
    elevation: 999,
  },
  container: {
    flex: 1,
    justifyContent: "center",
  },
  title: {
    alignSelf: "center",
    fontSize: 36,
    fontFamily: AppTheme.fonts.BUBBLE_BOBBLE,
    color: AppTheme.colors.white,
    textShadowColor: AppTheme.colors.outline,
    textShadowOffset: { width: 2, height: 2 },
    textShadowRadius: 2,
  },
  text: {
    alignSelf: "center",
    fontSize: 20,
    fontFamily: AppTheme.fonts.ALEXANDRIA_SEMIBOLD,
    color: AppTheme.colors.white,
  },
  btnView: {
    width: "100%",
    flexDirection: "row",
    alignItems: "center",
    justifyContent: "space-between",
  },
  btn: {
    width: "48%",
    height: 130,
  },
  btnImg: {
    width: "100%",
    height: "100%",
    position: "relative",
    overflow: "visible",
    justifyContent: "flex-end",
  },
  smallIcon: {
    position: "absolute",
    width: 90,
    height: 90,
    alignSelf: "center",
    zIndex: 999,
  },
  btnText: {
    alignSelf: "center",
    fontSize: 24,
    fontFamily: AppTheme.fonts.BUBBLE_BOBBLE,
    color: AppTheme.colors.white,
    textShadowColor: AppTheme.colors.outline,
    textShadowOffset: { width: 2, height: 2 },
    textShadowRadius: 2,
  },
  selectdeTokenBack: {
    width: "100%",
    height: 270,
    alignSelf: "center",
    paddingTop: 20,
  },
  chooseText: {
    textAlign: "center",
    color: AppTheme.colors.white,
    fontFamily: AppTheme.fonts.ALEXANDRIA_BOLD,
    fontSize: 25,
  },
  playerIcon1: {
    width: 80,
    height: 80,
  },
  label1: {
    fontSize: 20,
    fontFamily: AppTheme.fonts.BUBBLE_BOBBLE,
    color: AppTheme.colors.white,
    textShadowColor: AppTheme.colors.outline,
    textShadowOffset: { width: 2, height: 2 },
    textShadowRadius: 2,
  },
  tick: {
    width: 30,
    height: 30,
    marginTop: 10,
  },
  googleBtn: {
    width: 250,
    height: 58,
    borderRadius: 30,
    justifyContent: "center",
  },

  googleBtn1: {
    width: 250,
    height: 65,
    borderRadius: 35,
  },
  startText: {
    fontFamily: AppTheme.fonts.BUBBLE_BOBBLE,
    fontSize: 35,
    color: AppTheme.colors.white,
    textAlign: "center",
    textShadowColor: AppTheme.colors.outline,
    textShadowOffset: { width: 2, height: 2 },
    textShadowRadius: 2,
  },
  playerListView: {
    alignItems: "center",
    flexDirection: "row",
    justifyContent: "space-around",
    width: "100%",
  },
  playerItem: {
    flex: 1,
    marginTop: 15,
    alignItems: "center",
  },
  playerback: {
    justifyContent: "center",
    alignItems: "center",
    padding: 15,
  },
  playerIcon: {
    width: 80,
    height: 80,
  },
  label: {
    fontSize: 20,
    color: AppTheme.colors.white,
    fontFamily: AppTheme.fonts.BUBBLE_BOBBLE,
    textShadowColor: AppTheme.colors.outline,
    textShadowOffset: { width: 2, height: 2 },
    textShadowRadius: 2,
  },
  inputView: {
    width: "85%",
    height: 50,
    backgroundColor: `${AppTheme.colors.linearGradient_10}50`,
    alignSelf: "center",
    marginTop: 30,
    borderRadius: 10,
    borderWidth: 1,
    borderColor: AppTheme.colors.linearGradient_10,
    paddingHorizontal: 10,
  },
  input: {
    flex: 1,
    color: AppTheme.colors.white,
    fontSize: 18,
    fontFamily: AppTheme.fonts.ALEXANDRIA_MEDIUM,
  },
  modalView: {
    flex: 1,
    alignItems: "center",
    justifyContent: "center",
    backgroundColor: `${AppTheme.colors.black}90`,
  },
  botttomView: {
    position: "absolute",
    bottom: 10,
  },
});
